export var DEFAULT_ALLOWED_FILES_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'avi', 'mov', 'mp4', 'docx', 'doc', 'rtf', 'xlsx', 'xls', 'pdf', 'txt', 'csv', 'ods'];
export var DEFAULT_FILES_COUNT_LIMIT = 10;
export var DEFAULT_FILE_SIZE_LIMIT = 10 * 1024 * 1024; // 10 мегабайт